import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

interface Props {
  size?: number;
  className?: string;
}

const ModificationRequestInReviewIcon = ({ size = 24, className }: ClassAttributes<SVGElement> & Props) => (
  <Root
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    version="1.1"
    width={size}
    height={size}
    className={className}
  >
    <line x1="257.85" y1="146.6" x2="365.76" y2="146.6" />
    <line x1="257.85" y1="242.74" x2="365.76" y2="242.74" />
    <line x1="257.85" y1="342.83" x2="365.76" y2="342.83" />
    <path d="M58.15,168.63h48.37a19.28,19.28,0,0,0,0-38.55H58.15a19.28,19.28,0,0,0,0,38.55Z" />
    <path d="M381.19,13.66H106.28A43.6,43.6,0,0,0,62.69,57.25v52.66H98.75V57.25a7.55,7.55,0,0,1,7.53-7.53H381.19a33.07,33.07,0,0,1,33.08,33.07V416.35a33.08,33.08,0,0,1-33.08,33.07H106.28a7.56,7.56,0,0,1-7.53-7.53V389.23H62.69v52.66a43.6,43.6,0,0,0,43.59,43.59H381.19a69.14,69.14,0,0,0,69.14-69.13V82.79A69.14,69.14,0,0,0,381.19,13.66Z" />
    <rect x="62.69" y="188.8" width="36.06" height="121.54" />
    <path d="M125.78,349.79a19.27,19.27,0,0,0-19.26-19.28H58.15a19.28,19.28,0,0,0,0,38.55h48.37A19.27,19.27,0,0,0,125.78,349.79Z" />
    <polygon points="183.72 173.97 195.9 161.79 229.4 128.3 217.22 116.12 183.72 149.61 162.41 128.3 150.23 140.48 183.72 173.97" />
    <polygon points="217.22 219.31 183.72 252.8 162.41 231.48 150.23 243.66 183.72 277.16 195.9 264.98 229.4 231.48 217.22 219.31" />
    <g>
      <rect fill="none" height="24" width="24" />
    </g>
    <path d="M15,21h-2v-2h2V21z M13,14h-2v5h2V14z M21,12h-2v4h2V12z M19,10h-2v2h2V10z M7,12H5v2h2V12z M5,10H3v2h2V10z M12,5h2V3h-2V5 z M4.5,4.5v3h3v-3H4.5z M9,9H3V3h6V9z M4.5,16.5v3h3v-3H4.5z M9,21H3v-6h6V21z M16.5,4.5v3h3v-3H16.5z M21,9h-6V3h6V9z M19,19v-3 l-4,0v2h2v3h4v-2H19z M17,12l-4,0v2h4V12z M13,10H7v2h2v2h2v-2h2V10z M14,9V7h-2V5h-2v4L14,9z M6.75,5.25h-1.5v1.5h1.5V5.25z M6.75,17.25h-1.5v1.5h1.5V17.25z M18.75,5.25h-1.5v1.5h1.5V5.25z" />
  </Root>
);

const Root = styled('svg')({ fill: 'currentColor' });

export default ModificationRequestInReviewIcon;
